"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Header = exports.hasAccentStyle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens/lib/tokens"));

var types = _interopRequireWildcard(require("../../types"));

var _sizeStyles;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var sizeStyles = (_sizeStyles = {}, (0, _defineProperty2["default"])(_sizeStyles, types.sizes.MEDIUM, (0, _styledComponents.css)(["font-weight:bold;height:", ";padding:", " 10px ", " ", ";", ""], (0, _helpers.spacer)(6), _tokens["default"].space, _tokens["default"].space, _stylers["default"].spacer(2), _stylers["default"].fontSize(1))), (0, _defineProperty2["default"])(_sizeStyles, types.sizes.LARGE, (0, _styledComponents.css)(["font-weight:bold;height:", ";padding:", " 18px ", " ", ";", ";"], (0, _helpers.spacer)(8), _stylers["default"].spacer(2), _stylers["default"].spacer(2), _stylers["default"].spacer(3), _stylers["default"].fontSize(3))), _sizeStyles);
var hasAccentStyle = (0, _styledComponents.css)(["border-top:", " solid ", ";"], _tokens["default"].spaceSm, _tokens["default"].color.blue);
exports.hasAccentStyle = hasAccentStyle;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "Headerstyles__Header",
  componentId: "sc-alzkw1-0"
})(function (_ref) {
  var size = _ref.size,
      hasAccent = _ref.hasAccent;
  return (0, _styledComponents.css)(["align-items:center;border-bottom:1px solid ", ";box-sizing:border-box;display:flex;justify-content:space-between;width:100%;&:focus{outline:0;}[data-pka-anchor=\"heading\"]{", " display:block;margin:0;}", ";", ";"], _tokens["default"].border.color, _stylers["default"].truncateText, sizeStyles[size], hasAccent ? hasAccentStyle : "");
});

exports.Header = Header;
//# sourceMappingURL=Header.styles.js.map